import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { requestPaymentUrl } from "../services/server-actions"; 


const Payment: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { trackingNumber } = location.state || {};

  useEffect(() => {
    const fetchPaymentUrl = async () => {
      try {
        if (!trackingNumber) {
          throw new Error("کد پیگیری یافت نشد.");
        }

        const paymentUrl = await requestPaymentUrl(trackingNumber);
        if (paymentUrl) {
          window.location.href = paymentUrl; // ریدایرکت به درگاه پرداخت
        } else {
          navigate("/payment-failed");
        }
      } catch (error) {
        console.error("❌ خطا در هدایت به درگاه:", error);
        navigate("/payment-failed");
      }
    };

    fetchPaymentUrl();
  }, [trackingNumber, navigate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>در حال انتقال به درگاه پرداخت...</h2>
      <p>لطفاً منتظر بمانید</p>
    </div>
  );
};

export default Payment;
